import React from 'react';
import { set, map, cloneDeep, isEqual, find, get, isBoolean } from 'lodash';
import shortid from 'shortid';

// React view component to render
import { callMarkResolveForm as CallMarkResolveForm } from 'ui/views/widgets/callMarkResolveForm';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { CallMarkResolved } from 'ui/containers/CallMarkResolved';
 *
 * // render
 * <CallMarkResolved propName='propValue'/>
 */
export class CallMarkResolved extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        const type = find( this.props.fields, { name: 'type' } );
        const selectedType = get( type, 'value', get( type, 'config.emptyValue' ) );

        this.state = {
            fields: this.props.fields,
            values: {},
            selectedType: selectedType,
            formId: shortid.generate()
        };

        this.handleFormUpdate = this.handleFormUpdate.bind( this );
        this.handleSubmitClick = this.handleSubmitClick.bind( this );
    }

    handleFormUpdate( { values } ) {
        log.debug( 'CallMarkResolved.handleFormUpdate()' );

        if( ! isEqual( this.state.selectedType, values.type ) ) {

            if( 'current' === values.type ) {

                const data = cloneDeep( this.state.fields );
                const fields = map( data, ( field ) => {
                
                    if( 'resolvedDate' === field.name || 'resolvedTime' === field.name ) {
                        set( field, 'config.readonly', true );
                    }
                    return field;
                } );
    
                set( values, 'resolvedDate', null );
                set( values, 'resolvedTime', null );
              
                this.setState( {
                    fields: fields,
                    values: values,
                    selectedType: values.type,
                    formId: shortid.generate()
                } );
                
            } else {
    
                const data = cloneDeep( this.state.fields );
                const fields = map( data, ( field ) => {
                
                    if( 'resolvedDate' === field.name || 'resolvedTime' === field.name ) {
                        set( field, 'config.readonly', false );
                    }
                    return field;
                } );
              
                this.setState( {
                    fields: fields,
                    values: values,
                    selectedType: values.type,
                    formId: shortid.generate()
                } );
            }
        }
    }


    handleSubmitClick( { values, isValid } ) {
        log.debug( 'CallMarkResolved.handleSubmitClick()' );

        if( isValid && isBoolean( isValid ) ) {
            this.props.onSumbitClick( { values } );
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <CallMarkResolveForm
                { ...this.props }
                fields={ this.state.fields }
                formId={ this.state.formId }
                values={ this.state.values }
                onFormUpdate={ this.handleFormUpdate }
                onSubmitClick={ this.handleSubmitClick }
            />
        );
    }
}

// set display name
CallMarkResolved.displayName = 'CallMarkResolved';

// set default props
CallMarkResolved.defaultProps = {};

// prop types
CallMarkResolved.propTypes = {};
